namespace TabAurous.Purchase {
    export interface GetLineNoResponse extends Serenity.ServiceResponse {
        Line_No?: number;
    }
}
